export default __webpack_public_path__ + "static/media/kick_verb.ed8bb269.mp3";